// src/components/CustomFields/fields/InputDateField.tsx
// InputDateField component - Migrated to react-datepicker with modern React

import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomFieldsService from '../../../api/CustomFieldsService';
import $ from 'jquery';
import moment from 'moment';
import './InputDateField.css';
import ClickOutSide from '../../Globals/ClickOutSide';
import type { BaseFieldProps, CustomFieldItem } from './types';

const InputDateField: React.FC<BaseFieldProps> = props =>
{
  const inputDateRef = useRef<HTMLDivElement>(null);

  const cf = props.customField;
  const initialValue =
    cf.Value === undefined || cf.Value === null || cf.Value === '' || cf.Value === 'Not Set'
      ? null
      : new Date(String(cf.Value));

  const [value, setValue] = useState<Date | null>(initialValue);
  const [editorEnabled, setEditorEnabled] = useState(props.EditorEnabled || false);
  const [editableValue, setEditableValue] = useState<Date | null>(null);
  const [customField, setCustomField] = useState<CustomFieldItem>(cf);
  const [canEdit] = useState(props.canEdit && cf.ConversationIsEnable !== false);
  const disableAutoSave = props.disableAutoSave || false;
  const idPicket = cf.CustomFieldValueId === undefined ? cf.CustomFieldId : cf.CustomFieldValueId;

  useEffect(() =>
  {
    const cf = props.customField;
    const currentValue = String(customField.Value || '');
    const nextValue = String(cf.Value || '');

    // Only update if the value actually changed to prevent infinite loops
    if (currentValue !== nextValue || customField.CustomFieldId !== cf.CustomFieldId)
    {
      const newValue =
        cf.Value === undefined || cf.Value === null || cf.Value === '' || cf.Value === 'Not Set'
          ? null
          : new Date(String(cf.Value));

      setCustomField(cf);
      setValue(newValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.customField.Value, props.customField.CustomFieldId]);

  const handleOnClose = () =>
  {
    $('body').find('.note-popover').attr('style', 'display:none');
    $('body').removeAttr('style');

    if (inputDateRef.current)
    {
      const element = $(inputDateRef.current);
      element.closest('.layer-details-container').off('scroll');
      element.closest('.card-body-area').off('scroll');
      element.closest('md-dialog-content').off('scroll');
      element.closest('.add-inline-task').off('scroll');
      element.closest('.corgee_com_card-body-info').off('scroll');
    }
  };

  const onCustomFieldUpdated = (param: CustomFieldItem) =>
  {
    if (props.onCustomFieldUpdated && typeof props.onCustomFieldUpdated === 'function')
    {
      props.onCustomFieldUpdated(param);
    }
  };

  const onUpdateCustomField = (updatedField?: CustomFieldItem) =>
  {
    if (props.UpdateCustomFields)
    {
      props.UpdateCustomFields(updatedField || customField);
    }
  };

  const save = (newValue: Date | null) =>
  {
    const copyCustomField = { ...customField };

    if (newValue?.getTime() !== editableValue?.getTime())
    {
      copyCustomField.Value = null;
      if (newValue !== null)
      {
        copyCustomField.Value = moment(newValue).format('MM/DD/YYYY');
      }
      copyCustomField.PreviousValue =
        editableValue === null || editableValue === undefined
          ? 'Not Set'
          : moment(editableValue).format('MM/DD/YYYY');

      setEditableValue(newValue);

      if (!disableAutoSave)
      {
        const requestSave = {
          api: props.apiConfig,
          request: copyCustomField,
        };

        if (
          copyCustomField.CustomFieldValueId === undefined ||
          copyCustomField.CustomFieldValueId === null ||
          copyCustomField.CustomFieldValueId === 0
        )
        {
          CustomFieldsService.savePost(requestSave).then((data: any) =>
          {
            copyCustomField.CustomFieldValueId = data.CustomFieldValueId;

            try
            {
              setCustomField(copyCustomField);

              setTimeout(() =>
              {
                onUpdateCustomField(copyCustomField);
                onCustomFieldUpdated(copyCustomField);
              });
            }
            catch (err)
            {
              // Handle error
            }
          });
        }
        else
        {
          if (props.loadingBarStart)
          {
            props.loadingBarStart();
          }
          CustomFieldsService.save(requestSave).then(() =>
          {
            try
            {
              setCustomField(copyCustomField);

              setTimeout(() =>
              {
                onUpdateCustomField(copyCustomField);
                onCustomFieldUpdated(copyCustomField);
              });
              if (props.loadingBarComplete)
              {
                props.loadingBarComplete();
              }
            }
            catch (err)
            {
              if (props.loadingBarComplete)
              {
                props.loadingBarComplete();
              }
            }
          });
        }
      }
      else
      {
        disableEditor();
        setCustomField(copyCustomField);
        setTimeout(() =>
        {
          onUpdateCustomField(copyCustomField);
        });
      }
    }
    else
    {
      disableEditor();
    }
  };

  const handleChange = (date: Date | null) =>
  {
    setValue(date);

    setTimeout(() =>
    {
      handleOnClose();
      save(date);
      if (date !== null)
      {
        disableEditor();
      }
    });
  };

  const enableEditor = () =>
  {
    if (canEdit && customField.ConversationIsEnable !== false)
    {
      setEditorEnabled(true);
      setEditableValue(value);
    }
  };

  const disableEditor = () =>
  {
    setEditorEnabled(false);
    $('body').attr('style', '');

    if (inputDateRef.current)
    {
      const element = $(inputDateRef.current);
      element.closest('.layer-details-container').off('scroll');
      element.closest('.card-body-area').off('scroll');
      element.closest('md-dialog-content').off('scroll');
      element.closest('.add-inline-task').off('scroll');
      element.closest('.corgee_com_card-body-info').off('scroll');
    }
  };

  const getPopperPlacement = (): 'top-start' | 'bottom-start' =>
  {
    if (!inputDateRef.current) return 'bottom-start';

    const control = $(inputDateRef.current).find('.react-datepicker-wrapper');
    const windowHeight = $(window).height() || 0;

    if (control.length > 0)
    {
      const top = (control.offset()?.top || 0) + 35 - ($('html').scrollTop() || 0);

      if (top >= 700)
      {
        return 'top-start';
      }
      else
      {
        if (windowHeight - 240 > top)
        {
          return 'bottom-start';
        }
        else
        {
          return 'top-start';
        }
      }
    }
    return 'bottom-start';
  };

  return (
    <div
      ref={inputDateRef}
      id="inputDateRef"
      className="corgee_com_custom-fields-field-A _DEL_field-A custom-field-id"
    >
      {customField.GroupMultiEditionType === 1 && (
        <i
          className="material-icons several-values enable-help-tooltip"
          title="Not all cards selected have this detail. The detail value will change only on applicable cards."
          data-title="Not all cards selected have this detail. The detail value will change only on applicable cards."
        >
          do_not_disturb_on
        </i>
      )}
      <span className="corgee_com_custom-fields-title _DEL_title">{customField.Name}</span>

      <div className="click-to-edit">
        {!editorEnabled ? (
          <div
            onClick={enableEditor}
            className={canEdit ? 'lbl-editable-input' : 'lbl-non-editable-input'}
            id={'input' + idPicket}
          >
            {value !== null ? moment(value).format('MM/DD/YYYY') : 'Not Set'}
          </div>
        ) : null}

        {editorEnabled ? (
          <div className="corgee_com_custom-fields-date">
            <ClickOutSide onClickOutSide={disableEditor}>
              <DatePicker
                selected={value}
                onChange={handleChange}
                onBlur={disableEditor}
                dateFormat="MM/dd/yyyy"
                autoFocus={true}
                popperPlacement={getPopperPlacement()}
                popperProps={{
                  strategy: 'fixed',
                }}
                showPopperArrow={false}
                className="form-control"
                wrapperClassName="datepicker-wrapper"
                calendarClassName="custom-datepicker-calendar"
              />
            </ClickOutSide>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default InputDateField;
